import React from 'react';
import { NewModal } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { useDeleteHighlightMutation } from 'lib/api/highlights/useDeleteHighlightMutation';
import { IHighlight } from 'lib/api/highlights/useQueryHighlights';

interface DeleteHighlightModalProps {
  highlight: IHighlight;
  onClose: () => void;
}

export const DeleteHighlightModal = ({
  highlight,
  onClose,
}: DeleteHighlightModalProps) => {
  const { mutateAsync: deleteHighlightMutation, isLoading: isDeleting } =
    useDeleteHighlightMutation(onClose);
  const onDelete = () => {
    deleteHighlightMutation({ id: highlight.highlightId });
  };

  return (
    <NewModal
      headerText='Delete Highlight'
      closeModal={onClose}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Flex flexDirection='column' gap='20px'>
        <div>{`Are you sure you want to delete the "${highlight.title}" highlight?`}</div>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text='Cancel'
            onClick={onClose}
            variant='secondary'
            disabled={isDeleting}
          />
          <Button
            text='Delete'
            onClick={onDelete}
            variant='destructive'
            loading={isDeleting}
            disabled={isDeleting}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};
